import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import { VideoSearchResultListPaginated } from '../../model/video-search-result.model';
import { VideoCardComponent } from '../video-card/video-card.component';

@Component({
  selector: 'app-video-grid',
  templateUrl: './video-grid.component.html',
  styleUrls: ['./video-grid.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    VideoCardComponent
  ]
})
export class VideoGridComponent implements OnChanges {

  @Input() videoSearchResultListPaginated: VideoSearchResultListPaginated = null;

  protected displayedVideoSearchResultListPaginated: VideoSearchResultListPaginated = null;
  protected skeletonVideoSearchResultListPaginated: VideoSearchResultListPaginated = null;

  constructor(
  ) {
    this.skeletonVideoSearchResultListPaginated = {
      videos: Array(10).fill(null),
      current_page: 0,
      has_next_page: false,
      has_previous_page: false,
      num_pages: 1,
    };
    this.displayedVideoSearchResultListPaginated = this.skeletonVideoSearchResultListPaginated;
  }

  ngOnChanges() {
    this.refreshVideoList();
  }

  private async refreshVideoList() {

    // If the videoSearchResultListPaginated is null, we keep the skeleton
    if (!this.videoSearchResultListPaginated) {
      this.displayedVideoSearchResultListPaginated = this.skeletonVideoSearchResultListPaginated;
    } else {
      this.displayedVideoSearchResultListPaginated = this.videoSearchResultListPaginated;
    }
  }

}
